export const toLowerLetter = (str: string) => {
  if (str) {
    return str.charAt(0).toLowerCase() + str.slice(1).toLowerCase();
  }
  return '';
};
